module.exports = __webpack_public_path__ + "static/media/sara.9ae257fc.png";